import React, { Component } from 'react';
import {Button,Input,Modal,ModalBody} from 'reactstrap';
import Select from 'react-select';
import WarningMessage from '../../../../components/Message/WarningMessage/WarningMessage';
import removeIcon from '../../../../assets/cancel.png';
import CreatableSelect from 'react-select/lib/Creatable';
import 'react-select/dist/react-select.css';

class ShareModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
       publicShare: [],
       invitedUsers: [],
       note: '',
       accessChanged: false
    }
  }

  componentWillReceiveProps(nextProps) {
    let {publicShare} = nextProps.toolDetails;
       if(publicShare && publicShare.length>0) {
          publicShare = publicShare.map(u => {
         return {email: u.email, access: true, sender:u.sender, date:u.date};
       })
       this.setState({publicShare, invitedUsers: [], accessChanged: false, note: ''});
       } else {
       this.setState({publicShare: [], invitedUsers: [], accessChanged: false, note: ''});
       }
  }


  handleShareTool = () => {
    let {invitedUsers, note, publicShare} = {...this.state};
    let {orgUserList} = this.props;
    publicShare = publicShare.map(share => {
       let foundUser = orgUserList.filter(user => user.email === share.email);
       if(foundUser.length>0){
         return foundUser[0];
       } else {
         return {email: share.email, date: share.date, sender: share.sender};
       }
    });
    let shareToolRequest = {shareArr: []};
    // console.log(publicShare)
    invitedUsers = invitedUsers.map(user => {
      if(user.className) {
       return {email: user.email, isNew: true, date: Date.now(), sender: this.props.currentUser};
      } else {
       return {userId: user._id, email: user.email, isNew: true, date: Date.now(), sender: this.props.currentUser};
      }
    })
    invitedUsers = [...invitedUsers, ...publicShare];
    shareToolRequest.shareArr = invitedUsers;
     if(note && note!=='') {
    shareToolRequest['note'] = note;
     }
     this.props.onShareTool(shareToolRequest);
  } 

// Handle save upadated changes 
  handleSaveChnages = () => {
    let {publicShare} = {...this.state};
    let shareToolRequest = {shareArr: []};
    publicShare = publicShare.filter(share => share.access);
    shareToolRequest.shareArr = publicShare;
    this.props.onShareTool(shareToolRequest);
  }


  removeShareAccess = (index) => {
    let {publicShare} = this.state;
    publicShare[index].access = false;
    this.setState({publicShare, accessChanged: true, invitedUsers: []});
  } 

  closeShareModal = () => {
    this.props.toggle();
    this.setState({publicShare: [], invitedUsers: [], accessChanged: false, note: ''});
  }

  render() { 
    let {showModal, orgUserList, allowRemoveShareToolEmails} = this.props;
    let {invitedUsers, note, accessChanged, publicShare} = this.state;
    orgUserList = orgUserList.filter(user => !user.className);
    orgUserList = orgUserList.filter(user => {
        let foundPublicShare = publicShare.filter(publicShareUser => publicShareUser.email===user.email);
        if(foundPublicShare.length>0)
           return false;
        else 
           return true;   
    });
    let alreadyShared = publicShare && publicShare.length > 0;
    return ( 
      <div>
        <Modal 
          isOpen={showModal}>
          <ModalBody style={{padding:'30px 0px'}}>
            <div className="row">
              <div className="offset-md-1 offset-lg-1 col-md-10 col-lg-10 pick-office-modal-body-title">
              Share with Others
              </div>
            </div>

            { alreadyShared  && <div className="row mt10">
              <div className="offset-md-1 offset-lg-1 col-md-10 col-lg-10 already-share">
              Already shared with
              </div>
            </div> }
            { alreadyShared && publicShare.map((user, index) => {
              return <div className={'row '.concat(index===0? 'mt10 ': '')}>
                <div className="col-md-10 col-lg-10 offset-md-1 offset-lg-1">
                  <div style={{marginLeft: '0px', marginRight: '0px'}} className={'row shared-with-user-row'.concat(index+1 === publicShare.length ? ' shared-with-user-bottom-border': '')}>
                    <div className={'col-md-11 col-lg-11'.concat( user.access ? ' shared-with-user-emailId': ' shared-with-user-emailId-removed')}>
                      <span className="ml5">
                        {user.email}
                      </span>
                    </div>
                    {/* {allowRemoveShareToolEmails && <div className="col-md-1 col-lg-1 text-center">
                      {user.access && <img src={removeIcon} className="cursor-pointer" onClick={() => this.removeShareAccess(index)} height="11px" width="11px" />}
                    </div>} */}
                  </div>
                </div>
              </div>
            })}
            
            {alreadyShared && !accessChanged && <div className="row mt40">
              <div className="offset-md-1 offset-lg-1 col-md-10 col-lg-10 already-share">
              Share with more people
              </div>
            </div>}

            {accessChanged && <div className="row mt40">
              <div className="offset-md-1 offset-lg-1 col-md-10 col-lg-10">
                <WarningMessage iconLeft='' msg="You made some changes that need to be saved." subMsg="" />
              </div>
          </div>}  
            {!accessChanged && <div className={'row mb10 '.concat(alreadyShared ? 'mt10': 'mt10')}>
              <div className="offset-md-1 offset-lg-1 col-md-10 col-lg-10">
              <div className="shareToolEmailAlert">
                Please insert commas or select return between different emails.
              </div>
                <CreatableSelect
                  name="share-tool-select"
                  placeholder={"e.g. john@johndoe.com..."}
                  value={invitedUsers}
                  onChange={(invitedUsers) => this.setState({ invitedUsers })}
                  options={orgUserList}
                  valueKey='_id'
                  labelKey='email'
                  clearable={false}
                  multi
                />
              </div>
            </div>}
            { (!alreadyShared || (alreadyShared && invitedUsers.length > 0)) && <div className={'row mb10'}>
              <div className="offset-md-1 offset-lg-1 col-md-10 col-lg-10">
              <Input
              type="textarea"
              rows="7"
              name="share-message"
              id="share-message"
              className="textarea-custom"
              style={{paddingBottom:'25px'}}
              onChange={(e) => this.setState({note: e.target.value})}
              value={note}
              placeholder="Add a note (optional)"
            />
              </div>
            </div>}
            <div className="row mt30">
              <div className="offset-md-1 offset-lg-1 col-sm-3 col-md-3">
                  {alreadyShared && accessChanged && <Button onClick={this.handleSaveChnages} className="float-right saveChangesBtn w100">
                  <span className="continueBtnTxt"><span className="mr10 flaticon-tick"></span>Save Changes</span>
                  </Button>}
                  {invitedUsers.length >0 && invitedUsers!==undefined? 
                    (!alreadyShared || invitedUsers.length > 0 || !invitedUsers) && <Button onClick={this.handleShareTool} className="float-right saveChangesBtn w100">
                     <span className="continueBtnTxt"><span className="mr10 flaticon-tick"></span>Send</span>
                    </Button>
                  :
                  !alreadyShared?
                  <Button disabled className="float-right saveChangesBtn saveChangesBtnNoClick w100">
                  <span className="continueBtnTxt"><span className="mr10 flaticon-tick"></span>Send</span>
                  </Button>
                  : 
                  null
                  }
                  
                   {alreadyShared && !accessChanged && invitedUsers.length === 0 && <Button className="float-left goBackBtn w100" onClick={this.closeShareModal}>
                  <span className="goBackBtnTxt">Done</span>
                </Button>}
              </div> 
              {(accessChanged || !alreadyShared || invitedUsers.length > 0) && <div className="col-sm-2 col-md-2">
                <Button className="float-left goBackBtn ml10 w100" onClick={this.closeShareModal}>
                  <span className="goBackBtnTxt">Cancel</span>
                </Button>
              </div>}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default ShareModal;